const TONES = {
  neutral: { bg: "#f0f0f0", border: "#e5e5e5", color: "#4b4b4b" },
  gold:    { bg: "#d7ffb8", border: "#b8f28a", color: "#4b9000" }, // primary green
  sage:    { bg: "#e9fbd9", border: "#b8f28a", color: "#58a700" },
  rust:    { bg: "#fff0db", border: "#ffd699", color: "#c25e00" }, // orange
  berry:   { bg: "#ffdfe0", border: "#ffb3b6", color: "#ea2b2b" },
  sky:     { bg: "#ddf4ff", border: "#a8e0ff", color: "#1899d6" },
  grape:   { bg: "#f3e3ff", border: "#e3c2ff", color: "#a560e8" },
  xp:      { bg: "#fff3c4", border: "#ffe066", color: "#b88600" },
  ink:     { bg: "var(--ink-900)", border: "var(--ink-900)", color: "#9ee84f" },
};

export default function Chip({ children, tone = "neutral", icon, className = "", style, ...rest }) {
  const t = TONES[tone] || TONES.neutral;
  const isInk = tone === "ink";
  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        whiteSpace: "nowrap",
        padding: isInk ? "4px 10px" : "5px 12px",
        borderRadius: 999,
        background: t.bg,
        border: `2px solid ${t.border}`,
        color: t.color,
        fontFamily: "var(--font-body)",
        fontWeight: isInk ? 800 : 700,
        fontSize: isInk ? 10 : 12,
        letterSpacing: isInk ? "0.1em" : 0,
        textTransform: isInk ? "uppercase" : "none",
        ...style,
      }}
      {...rest}
    >
      {icon}
      {children}
    </span>
  );
}
